import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBasqueCountry = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_207)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.101624 13.5652C0.380811 15.708 1.22559 17.6728 2.48076 19.3057L8.86955 13.5652H0.101624Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.4348 23.8984V15.1305L4.6943 21.5193C6.32728 22.7745 8.292 23.6193 10.4348 23.8984Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.4348 0.101578C8.292 0.380765 6.32728 1.22555 4.6943 2.48072L10.4348 8.86959V0.101578Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.101624 10.4348H8.86955L2.48072 4.6943C1.22555 6.32724 0.380764 8.292 0.101624 10.4348Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.5652 0.101578V8.86954L19.3058 2.48072C17.6728 1.22564 15.708 0.380718 13.5652 0.101578Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.8984 10.4348C23.6192 8.292 22.7744 6.32724 21.5193 4.69425L15.1304 10.4348H23.8984Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.1304 13.5652L21.5193 19.3058C22.7744 17.6728 23.6193 15.708 23.8985 13.5652H15.1304Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.5652 23.8984C15.708 23.6192 17.6728 22.7745 19.3057 21.5192L13.5652 15.1305V23.8984Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.5202 19.3067L14.2136 12L14.2136 12L21.5202 4.69331C21.2051 4.28381 20.8604 3.88988 20.4853 3.51469C20.1102 3.13959 19.7162 2.79483 19.3067 2.47978L12 9.78642H12L4.69336 2.47978C4.28386 2.79488 3.88988 3.13955 3.51469 3.51469C3.13959 3.88988 2.79483 4.28381 2.47978 4.69336L9.78642 12L9.78647 12L2.47983 19.3067C2.79492 19.7161 3.13964 20.1101 3.51474 20.4853C3.88988 20.8604 4.28386 21.2052 4.69341 21.5202L12 14.2136L19.3067 21.5202C19.7161 21.2051 20.1101 20.8604 20.4853 20.4853C20.8604 20.1101 21.2051 19.7161 21.5202 19.3067Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.5652 23.8984V13.5653V13.5653H23.8984C23.9652 13.0529 24 12.5305 24 12C24 11.4696 23.9652 10.9472 23.8984 10.4348H13.5653L13.5653 10.4348V0.101625C13.0529 0.0349219 12.5306 0 12 0C11.4695 4.6875e-05 10.9471 0.0349219 10.4348 0.101625L10.4348 10.4347V10.4348H0.101625C0.034875 10.9471 0 11.4695 0 12C4.6875e-05 12.5306 0.034875 13.0529 0.101625 13.5652H10.4347L10.4348 23.8984C10.9472 23.9651 11.4694 24 12 24C12.5306 24 13.0529 23.9651 13.5652 23.8984Z",
				fill: "#F0F0F0"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_207",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgBasqueCountry;
